export const INPUT_MANAGEMENT_BOOKING_MODEL_LIST = 'INPUT_MANAGEMENT_BOOKING_MODEL_LIST'
export const INPUT_MANAGEMENT_BOOKING_SEARCH = 'INPUT_MANAGEMENT_BOOKING_SEARCH'
export const INPUT_MANAGEMENT_BOOKING_PAGINATION = 'INPUT_MANAGEMENT_BOOKING_PAGINATION'
export const INPUT_MANAGEMENT_BOOKING_DROP_DOWN_SEARCH_TYPE = 'INPUT_MANAGEMENT_BOOKING_DROP_DOWN_SEARCH_TYPE'